
import moment from "moment";
import { mapState, mapGetters, mapActions } from "vuex";
import noDataLabel from "../common/no-data-label.vue";
export default {
  components: { noDataLabel },
  data() {
    return {
      periods: [
        { value: "hour", label: "Hourly" },
        { value: "day", label: "Daily" }
      ],
      selectedPeriod: "",
      menu: false,
      series: [
        {
          name: "Orders",
          data: []
        }
      ],
      chartOptions: {
        chart: {
          height: 350,
          type: "bar",
          toolbar: {
            show: false
          },
          zoom: {
            enabled: false
          }
        },
        plotOptions: {
          bar: {
            borderRadius: 5,
            // columnWidth: "20px",
            dataLabels: {
              position: "top" // top, center, bottom
            }
          }
        },
        dataLabels: {
          enabled: false,
          offsetY: -20,
          style: {
            fontSize: "12px",
            colors: ["#304758"]
          }
        },

        xaxis: {
          labels: {},
          categories: [],
          position: "bottom",
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          },
          crosshairs: {
            fill: {
              type: "gradient",
              gradient: {
                colorFrom: "#D8E3F0",
                colorTo: "#BED1E6",
                stops: [0, 100],
                opacityFrom: 0.4,
                opacityTo: 0.5
              }
            }
          },
          tooltip: {
            enabled: true
          }
        },
        yaxis: {
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          },
          labels: {
            show: false
          }
        },
        tooltip: {
          x: {
            show: true
          }
        }
      }
    };
  },
  computed: {
    ...mapState("report", [
      "peakHours",
      "peakHoursLoading",
      "selectedTimeRange"
    ]),
    getLabel() {
      return (
        this.periods.find((el) => el.value == this.selectedPeriod)?.label ||
        "Select period"
      );
    }
  },
  mounted() {
    this.selectedPeriod = this.periods[0].value;
    this.fetchPeakHours();
  },
  methods: {
    ...mapActions("report", ["getPeakHours"]),
    async fetchPeakHours(backgroundLoad = true) {
      const $this = this;
      this.series[0].data = [];
      const today = new Date().toISOString().split("T")[0];
      await this.getPeakHours({
        data: { period: this.selectedPeriod },
        backgroundLoad
      });
      if (this.selectedPeriod == "hour") {
        this.chartOptions.xaxis = {
          type: "datetime",
          labels: {
            datetimeUTC: false,
            datetimeFormatter: {
              hour: "hh:mm TT"
            }
          }
        };
        this.chartOptions.xaxis.categories = this.peakHours.times?.map(
          (el) => `${today}T${el}`
          // this.convertTime24to12(el)
        );
        this.chartOptions.tooltip.x.formatter = (val) => {
          return moment(val).format("h:mm a");
        };
      } else {
        this.chartOptions.xaxis = {};
        this.chartOptions.xaxis.categories = this.peakHours.times;
        this.chartOptions.tooltip.x.formatter = (val) => val;
      }
      this.series[0].data = this.peakHours.data;
    }
  }
};
